import { render } from "./MenuSettings.vue?vue&type=template&id=19b6860a&scoped=true"
import script from "./MenuSettings.vue?vue&type=script&lang=js"
export * from "./MenuSettings.vue?vue&type=script&lang=js"

import "./MenuSettings.vue?vue&type=style&index=0&id=19b6860a&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b6860a"]])

export default __exports__